// SPDX-License-Identifier: AGPL-3.0-or-later
import type { Dataset, Route } from '../types';
import { esc } from '../format';
import { generateInsights } from '../analysis';
import { navigate } from '../main';

export function renderInsights(root: HTMLElement, d: Dataset, _route: Route): void {
  const insights = generateInsights(d);
  root.innerHTML = `
    <div class="view-head">
      <h2>Insights</h2>
      <p>Findings detected automatically from the latest Register — the patterns a single headline number hides. Each links through to the view where you can check it yourself.</p>
    </div>
    <div class="insight-grid">
      ${insights.map((ins, i) => `
        <div class="insight ${ins.severity}">
          <h3>${esc(ins.title)}</h3>
          <p>${esc(ins.body)}</p>
          ${ins.go ? `<button data-i="${i}">${esc(ins.go.label)} →</button>` : ''}
        </div>`).join('')}
    </div>
  `;
  root.querySelectorAll<HTMLButtonElement>('.insight button[data-i]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const g = insights[+btn.dataset.i!].go!;
      navigate({ view: g.view as Route['view'], country: g.country, state: g.state, cls: g.cls });
    });
  });
}
